<template>
  <div class="store-detail-main-page">
    <main-header :hasBanner="true"></main-header>
    <section class="main-center list-clr">
      <list-left ></list-left>
      <div class="page-right">
        <div class="info-bottom">
          <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">门店名称</div>
              <div class="lab-right">{{obj.name}}</div>
            </div>
            <div class="lab-item">
              <div class="user-img-box">
              <img class="user-img" :src="obj.userImg" alt="">
              </div>
            </div>
          </div>
          <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">资质证书号</div>
              <div class="lab-right"></div>
            </div>
            <div class="lab-item">

            </div>
          </div>
          <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">固定经营场所</div>
              <div class="lab-right">{{obj.address}}</div>
            </div>
            <div class="lab-item">

            </div>
          </div>
            <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">营业执照号</div>
              <div class="lab-right">{{obj.creditCode}}</div>
            </div>
            <div class="lab-item">

            </div>
          </div>
          <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">注册资金</div>
              <div class="lab-right">{{obj.registeredCapital}} <span v-if="obj.registeredCapital">万元</span></div>
            </div>
            <div class="lab-item">
              <div class="lab-left">负责人</div>
              <div class="lab-right">{{obj.charge}}</div>
            </div>
          </div>
          <div class="lab-row">
            <div class="lab-item">
              <div class="lab-left">星级级数</div>
              <div class="lab-right"></div>
            </div>
            <div class="lab-item">
              <div class="lab-left">所属机构</div>
              <div class="lab-right">{{obj.companyName}}</div>
            </div>
          </div>
        
        </div>

        <div class="i-r-t">机构网签地点</div>
        <div id="mapBox"></div>
      </div>
    </section>
    <main-footer></main-footer>
  </div>
</template>

<script>
import vueQr from "vue-qr";
import mainHeader from "@/components/mainHeader";
import mainFooter from "@/components/mainFooter";
import listLeft from "@/components/listLeft";
import { storeDetail } from "@/assets/api/store";

export default {
  name: "App",
  components: {
    mainHeader,
    mainFooter,
    vueQr,
    listLeft,
  },

  data() {
    return {
      id: this.$route.query.id,
      obj: '',
    };
  },
  computed: {},
  mounted() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      const res = await storeDetail({ id: this.id });
      if (res && res.data && res.data.code == 200) {
        this.obj = res.data.data
        // this.obj.userImg = `${this.$globalData.imgFile}${this.obj.photo}`
        this.initMap()
      }
    },
   initMap() {
      var map = new BMapGL.Map("mapBox");
      // 创建地图实例
      var point = new BMapGL.Point(this.obj.lng || 116.404, this.obj.lat || 39.915);
      map.centerAndZoom(point, 13);
      map.enableScrollWheelZoom(true); // 开启鼠标滚轮缩放
      if (this.obj.lng && this.obj.lat) {
        let point = new BMapGL.Point(this.obj.lng, this.obj.lat);
        let marker = new BMapGL.Marker(point); // 创建标注
        map.addOverlay(marker); // 将标注添加到地图中
                // 创建点坐标
        let obj = {
            title: this.obj.name,
            message: this.obj.address,
            Longitude: this.obj.lng,
            latitude: this.obj.lat,
            width: 200, // 信息窗口宽度
            height: 100, // 信息窗口高度
        }
        var infoWindow = new BMapGL.InfoWindow(this.obj.address, obj); // 创建信息窗口对象
        map.openInfoWindow(infoWindow, point); //开启信息窗口
        marker.addEventListener("onmouseover", function () {
          map.openInfoWindow(infoWindow, point); //开启信息窗口
        });
      }
    },
    
  },
};
</script>

<style lang="less">
.store-detail-main-page {
  background: #fff;
  .list-clr {
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
    .page-right {
      width: 848px;
      .info-bottom {
        line-height: 32px;
      }
      .i-r-t {
        font-size: 16px;
        margin: 20px 0;
      }
      .lab-item {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #555;
        font-size: 14px;
        .lab-left {
          width: 170px;
          min-height: 80px;
          flex-shrink: 0;
          border: 1px solid #eee;
          padding: 20px 20px;
          background: #fafafa;
          border-bottom: none;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .lab-right {
          flex: 1;
          min-height: 80px;
          border: 1px solid #eee;
          padding: 20px 20px;
          border-left: none;
          border-bottom: none;
                    display: flex;
          align-items: center;
        }
      }
      .lab-row {
        display: flex;
        .lab-item {
          flex: 1;
          &:nth-of-type(2n) {
            .lab-left {
              border-left: none;
            }
          }
          position: relative;
          .user-img-box {
            position: absolute;
            top:0;
            left: 0;
            width: 100%;
            height: 240px;
            border-right: 1px solid #eee;
            border-top: 1px solid #eee;

}
          .user-img {
            position: absolute;
            width: 200px;
            height: 266px;
            top: 20px;
            left: 0;
            right: 0;
            margin: auto;
            object-fit: cover;
          }
        }
        &:last-child {
          .lab-left {
            border-bottom: 1px solid #eee;
          }
          .lab-right {
            border-bottom: 1px solid #eee;
          }
        }

        &:nth-last-child(2) {
          & > div:last-child {
            .lab-left {
              border-bottom: 1px solid #eee;
            }
            .lab-right {
              border-bottom: 1px solid #eee;
            }
          }
        }
      }
    }

    .mg-t20 {
      margin-top: 20px;
    }
    #mapBox {
      width: 100%;
      height: 500px;
    }
  }
  .BMap_bubble_title {
    width: 180px!important;
     white-space: nowrap!important;
    text-overflow: ellipsis!important;
    overflow: hidden!important;
    word-break: break-all!important;
  }
}
</style>